import { CloseOutlined } from "@ant-design/icons";
import React from "react";
import { VimeoItem } from "../Works";

interface WorkModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  item: VimeoItem | null;
}

const WorkModal: React.FC<WorkModalProps> = ({
  showModal,
  setShowModal,
  item,
}) => {
  if (!showModal || !item) return <></>;

  return (
    <div className='works-modal'>
      <div className='close-btn' onClick={() => setShowModal(false)}>
        <CloseOutlined />
      </div>

      <div className='works-modal-body'>
        <div className='works-modal-video'>
          <iframe
            id='iMovie'
            title='mainVideo'
            name='movieFrame'
            width={"100%"}
            height={"100%"}
            src={`https://player.vimeo.com/video/${item.id}`}
            frameBorder='0'
            allow='autoplay; fullscreen'
            allowFullScreen
          />
        </div>

        <div className='works-modal-info'>
          <p className='works-modal-title'>{item.title}</p>
        </div>

        <a href='mailto:loocreative@playlooc.com' className='works-contact'>
          Contact us
        </a>
      </div>
    </div>
  );
};

export default WorkModal;
